module.exports = __webpack_public_path__ + "static/img/硬舉.62db38f8.png";